<template>
  <v-container fluid class="pa-2">

    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>
    
    
    <!-- EVENT ITEMS -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0" v-if="!isLoading && translatedEvents.length">
      
      <template v-for="item in translatedEvents">
        <div v-if="item.translation" class="ma-0 pa-2" :class="'col-' + (12 / columns)" :key="item.identifier">
          <v-card
              height="100%"
              link
              flat
              class="rounded-lg d-flex flex-column link-on-hover"
              hover
              @click.prevent="openItem(item)"
          >
            <v-img
                v-if="item.translation.thumbnailUrl"
                :src="item.translation.thumbnailUrl"
                lazy-src="/assets/img/placeholder.png"
                :aspect-ratio="16/9"
                class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
                eager
                cover
            ></v-img>
            <v-img
                v-else-if="item.thumbnailUrl"
                :src="item.thumbnailUrl"
                lazy-src="/assets/img/placeholder.png"
                :aspect-ratio="16/9"
                class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
                eager
                cover
            ></v-img>
            <v-card-title class="text-break"><strong>{{ item.translation.title }}</strong></v-card-title>
<!--            <v-card-subtitle>{{ $moment(item.from).format("DD/MM/YYYY") }} - {{ $moment(item.until).format("DD/MM/YYYY") }}</v-card-subtitle>-->
            <v-card-text class="fill-height">
              <div v-if="item.translation.shortDescription" v-html="item.translation.shortDescription"></div>
            </v-card-text>
          </v-card>
        </div>
      </template>

    </div>


    <!-- EVENT DIALOG -->
    <v-dialog
        v-model="showItemDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-img
            v-if="selectedItem.translation && selectedItem.translation.thumbnailUrl"
            :src="selectedItem.translation.thumbnailUrl"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
            :aspect-ratio="16/9"
            class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
            eager
            cover
        ></v-img>
        <v-img
            v-else-if="selectedItem.thumbnailUrl"
            :src="selectedItem.thumbnailUrl"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
            :aspect-ratio="16/9"
            class="grey d-flex justify-start align-end flex-wrap pa-2 ma-4 rounded-lg overflow-hidden"
            eager
            cover
        ></v-img>
        <v-btn
            class="mt-3"
            color="primary"
            fab
            depressed
            dark
            small
            absolute
            right
            @click.prevent="showItemDialog = false"
        >
          <v-icon small>fal fa-close</v-icon>
        </v-btn>
        <v-card-title v-if="selectedItem.translation && selectedItem.translation.title" class="text-break"><strong>{{ selectedItem.translation.title }}</strong></v-card-title>
<!--        <v-card-subtitle>{{ $moment(selectedItem.from).format("DD/MM/YYYY") }} - {{ $moment(selectedItem.until).format("DD/MM/YYYY") }}</v-card-subtitle>-->
        <v-card-text class="fill-height">
          <div v-if="selectedItem.translation && selectedItem.translation.description" v-html="selectedItem.translation.description"></div>
        </v-card-text>
          <v-divider v-if="(selectedItem.translation && selectedItem.translation.url) || selectedItem.registrationModule"></v-divider>
          <v-card-actions class="justify-end mt-auto" v-if="(selectedItem.translation && selectedItem.translation.url) || selectedItem.registrationModule">
              <template v-if="selectedItem.registrationModule">
                  <template v-if="!selectedItem.registrationModule.registered">
                      <v-btn
                              color="primary"
                              depressed
                              class="rounded-lg"
                              :loading="registrationLoading"
                              :disabled="!(selectedItem.registrationModule.registerCount < selectedItem.registrationModule.maxParticipants) || !$moment(selectedItem.registrationModule.startRegistrationDate).isSameOrBefore($moment(), 'day') || !$moment(selectedItem.registrationModule.endRegistrationDate).isSameOrAfter($moment(), 'day')"
                              @click.prevent="checkConsentAndRegisterForEvent()"
                      >
                          {{ $t('buttons.register') }}
                      </v-btn>
                  </template>
                  <template v-if="selectedItem.registrationModule.registered">
                      <v-btn
                              color="primary"
                              depressed
                              class="rounded-lg"
                              :loading="registrationLoading"
                              :disabled="!$moment(selectedItem.registrationModule.startRegistrationDate).isSameOrBefore($moment(), 'day') || !$moment(selectedItem.registrationModule.endRegistrationDate).isSameOrAfter($moment(), 'day')"
                              @click.prevent="deleteRegistrationForEvent()"
                      >
                          {{ $t('buttons.deregister') }}
                      </v-btn>
                  </template>
              </template>
              <template v-else-if="selectedItem.translation && selectedItem.translation.url">
                  <v-btn
                          color="primary"
                          depressed
                          class="rounded-lg"
                          @click.prevent="navigate(selectedItem.translation.url)"
                  >
                      {{ $t('buttons.participate') }}
                  </v-btn>
              </template>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CONSENT DIALOG -->
    <m2h-consent-dialog></m2h-consent-dialog>
    
  </v-container>
</template>

<script>

import api from "@/api/api";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "m2h-events",
  data() {
    return {
      isLoading: true,
      events: [],
      eventsV2: [],
      showItemDialog: false,
      selectedItem: {},
      registrationLoading: false,
      acceptConsent: false,
      consent: {},
      handleConsentLoading: false,
      consentDialogIdentifier: ''
    }
  },

  computed: {
    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 4;
      }

      if (this.$vuetify.breakpoint.lg) {
        return 3;
      }

      if (this.$vuetify.breakpoint.md) {
        return 3;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 2;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 1;
      }

      return 1;
    },

    translatedEvents() {
      let events = [...this.eventsV2]
      events.forEach((event) => {
        event.translation = null
        if (event.translations && event.translations.length){
          if (event.translations.find((t) => t.language === this.$i18n.locale)){
            event.translation = event.translations.find((t) => t.language === this.$i18n.locale)
          }
        }
      })
      return events
    }

  },

  mounted(){
    //this.fetchEvents()
    this.fetchEventsV2()
    this.$root.$on('handle-consent-dialog', (data) => {
      if (data.consentDialogIdentifier === this.consentDialogIdentifier){
        this.registerForEvent()
      }
    })
  },

  methods: {
    async fetchEvents(){
      this.isLoading = true
      let events = []
      events = await api.newsItems.getList("event", this.$i18n.locale).then((res) => { return res.data })
      if (events.length){
        this.events = events.sort((a, b) => {
          return this.$moment(a.created).unix() - this.$moment(b.created).unix()
        })
        for (const item of this.events) {
          let image = await this.fetchImage(item.imageAssetId)
          let thumbnail = await this.fetchImage(item.thumbnailAssetId)
          item.image = image
          item.thumbnail = thumbnail
        }
      }
      this.isLoading = false
    },

    async fetchEventsV2(){
      this.isLoading = true
      let events = []
      events = await api.happenings.getList().then((res) => { return res.data })
      if (events.length){
        this.eventsV2 = events.sort((a, b) => {
          return this.$moment(b.visibleFrom).unix() - this.$moment(a.visibleFrom).unix()
        })
      }
      this.isLoading = false
    },

    async fetchImage(id){
      if (id){
        return await api.newsItems.getSas(id)
            .then((res) => {
              return res.data
            })
            .catch(() => {
              return ''
            })
      } else {
        return ''
      }
    },
    
    async openItem(item){
      this.selectedItem = item
      if (item.registrationModule && item.registrationModule.identifier){
          this.selectedItem.registrationModule.registered = await api.userRegistrations.getRegistrationExists(item.registrationModule.identifier).then((res) => {
              return res.data
          })
          await this.updateRegisterCount()
      }
      this.showItemDialog = true
      this.$root.$emit('post-event-opened', { id: item.identifier })
    },

    async registerForEvent(){
        this.registrationLoading = true
        await this.updateRegisterCount()
        if (this.selectedItem.registrationModule.registerCount < this.selectedItem.registrationModule.maxParticipants){
            let registration = await api.userRegistrations.postRegistrationRegister(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
            if (registration.identifier){
                this.selectedItem.registrationModule.registered = true
                await this.updateRegisterCount()
                this.$root.$emit('open-snackbar', { mode: "registered", title: this.selectedItem.title })
            }
        }
        this.registrationLoading = false
    },

    async updateRegisterCount(){
        this.selectedItem.registrationModule.registerCount = await api.userRegistrations.getRegistrationCount(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
    },

    async deleteRegistrationForEvent(){
        this.registrationLoading = true
        let registration = await api.userRegistrations.getRegistration(this.selectedItem.registrationModule.identifier).then((res) => { return res.data })
        if (registration.identifier){
            await api.userRegistrations.deleteRegistration(registration.identifier)
            this.selectedItem.registrationModule.registered = false
            this.$root.$emit('open-snackbar', { mode: "deregistered", title: this.selectedItem.title })
        }
        await this.updateRegisterCount()
        this.registrationLoading = false
    },
      
    async checkConsent(){
        this.consent = await api.consent.getForLabel(this.selectedItem.registrationModule.consentLabel).then((res) => { return res.data })
        this.acceptConsent = this.consent.approved
    },

    async checkConsentAndRegisterForEvent(){
        this.registrationLoading = true
        await this.checkConsent()
        if (this.acceptConsent){
            await this.registerForEvent()
        } else {
          this.consentDialogIdentifier = uuidv4();
          this.$root.$emit('open-consent-dialog', { consentDialogIdentifier: this.consentDialogIdentifier, consentLabel: this.selectedItem.registrationModule.consentLabel })
        }
        this.registrationLoading = false
    },

    navigate(route){
      //window.location.href = route
      if (route){
        window.open(route, '_blank');
      }
    },
  }
}
</script>

<style scoped>

</style>
